import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { CODICI, PRINCIPALE, contesto, valida } from '../i18n';

// La lingua delle pagine che stanno FUORI dall'area del cliente: accesso, registrazione, pagina non trovata,
// privacy e termini. Lì il cliente non è ancora entrato, quindi non c'è un profilo da cui prendere la lingua
// (dentro l'area ci pensa LayoutCliente con FornitoreLingua): si propone quella del browser, se è una delle
// nostre cinque. Chi è già entrato tiene la sua, anche su queste pagine.
//
// Lo staff apre le stesse pagine: il suo `lingua` è sempre "it" (linguaDelUtente in i18n.js), quindi resta in
// italiano appena entrato. Prima di entrare vale il browser, come per tutti.

// "ru-RU" → "ru". Si guardano tutte le lingue preferite, nell'ordine del browser, e vince la prima che conosciamo.
export const linguaDelBrowser = (lingue) => {
  const elenco = lingue
    || (typeof navigator === 'undefined' ? [] : (navigator.languages?.length ? navigator.languages : [navigator.language]));
  for (const tag of elenco) {
    const codice = String(tag || '').toLowerCase().split('-')[0];
    if (CODICI.includes(codice)) return codice;
  }
  return PRINCIPALE;
};

export const useLinguaOspite = () => {
  const auth = useContext(AuthContext);
  return auth?.user ? valida(auth.lingua) : linguaDelBrowser();
};

// Come useTraduzioni(), ma per queste pagine: const { t, l } = useTraduzioniOspite();
export const useTraduzioniOspite = () => contesto(useLinguaOspite());
